<template>
    <v-row class="profile-dashboard">
        <v-col cols="12" md="6">
            <ProfileCard class="profile-card"></ProfileCard>
        </v-col>
        <v-col cols="12" md="6">
            <v-row>
                <v-col cols="12">
                    <div class="referral">
                        <div class="referral-title mb-4">Your Referral Code</div>
                        <ReferralCodeTile></ReferralCodeTile>
                    </div>
                </v-col>
                <v-col cols="12">
                    <CommissionTile class="commission"></CommissionTile>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>



<script setup>

import ProfileCard from "./Profile-Card.vue";
import CommissionTile from "@/components/Tiles/Referral/Commission-Tile.vue";
import ReferralCodeTile from "@/components/Tiles/Referral/Referral-Code-Tile.vue";

</script>